
export class TeamRoleMember {
    public id: string;
    public member_id: string;    
    public member_name: string;    
    public role_id: string;    
    public role_name: string;    
    constructor() {}
}

